import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import OptimizerPage from '../pages/Optimizer/OptimizerPage';
import OptimizerListPage from '../pages/OptimizerList/OptimizerListPage';
import OptimizerCostsResultsPage from '../pages/OptimizerCostsResults/OptimizerCostsResultsPage';
import CalendarPage from '../pages/Calendar/CalendarPage';
import ForecastingPage from '../pages/Forecasting/ForecastingPage';
import SignUpForm from '../pages/Auth/SignUp';
import SignInForm from '../pages/Auth/SignIn';
import SummarizePage from '../pages/Summarize/SummarizePage';
import PrivacyPolicyPage from '../pages/PrivacyPolicy/PrivacyPolicyPage';
import TermsOfServicePage from '../pages/TermsOfService/TermsOfServicePage';
import ProtectedRoute from './ProtectedRoute';
const Navigation = () => {
  return (
    <Routes>
      <Route
        path="optimizer"
        element={<ProtectedRoute element={<OptimizerPage />} />}
      />
      <Route
        path="optimizer-list"
        element={<ProtectedRoute element={<OptimizerListPage />} />}
      />
      <Route
        path="optimizer-costs-results"
        element={<ProtectedRoute element={<OptimizerCostsResultsPage />} />}
      />
      <Route
        path="summarize"
        element={<ProtectedRoute element={<SummarizePage />} />}
      />
      <Route
        path="calendar"
        element={<ProtectedRoute element={<CalendarPage />} />}
      />
      <Route
        path="forecasting"
        element={<ProtectedRoute element={<ForecastingPage />} />}
      />
      <Route
        path="privacy-policy"
        element={<ProtectedRoute element={<PrivacyPolicyPage />} />}
      />
      <Route
        path="terms-of-service"
        element={<ProtectedRoute element={<TermsOfServicePage />} />}
      />
      <Route path="signup" element={<SignUpForm />} />
      <Route path="signin" element={<SignInForm />} />
      <Route path="*" element={<Navigate to="optimizer" replace />} />
    </Routes>
  );
};
export default Navigation;
